import Vue from 'vue'
import axios from 'axios'
import { clearIdleActivityMarker } from '@/utils/sessionIdle'
import { extraerRutasDesdeMenu } from '@/utils/extraerRutasMenu'
import { estatusRecepcionDeMap } from '@/utils/estatusVendedoraRanking'

export default{
	namespaced: true,
	state:{
		login:false,
		datosUsuarioERP:'',
		escuela: 1,
		drawer: false,
		prospecto:null,
		estatusLlamada: 0,
		estatusLlamadaRecluta:0,
		tareas:[],
		nuevosProspectos:0,
		menu:[],
		permisosRutas: [],
		estatusRecepcionMap: {},
		estatusRecepcionVersion: 0,
		estatusRecepcionLocalTs: {},
		reconocimientoMoisesVisto: false,
	},

	mutations:{
		LOGEADO(state, value){
			state.login = value
		},

		DATOS_USUARIO(state, datosUsuarioERP){
      state.datosUsuarioERP = datosUsuarioERP
		},

		SALIR(state){
			state.login = false
			state.datosUsuarioERP = ''
			state.clientes = []
			state.cliente = ''
			state.vendedor = ''
			state.menu = []
			state.permisosRutas = []
			state.estatusRecepcionMap = {}
			state.estatusRecepcionVersion = 0
			state.estatusRecepcionLocalTs = {}
		},

		CAMIAR_ESCUELA(state, escuela){
      state.escuela = escuela
		},

		ABRIR_PROSPECTO(state, prospecto){
			state.prospecto = prospecto
		},

		CAMBIAR_ESTATUS_LLAMADA(state, estatusLlamada){
			state.estatusLlamada = estatusLlamada
		},

		ADD_TAREAS(state, tareas){
			state.tareas = tareas
		},

		ADD_NUEVOS_PROSPECTOS(state, nuevos){
			state.nuevosProspectos = nuevos
		},

		ADD_MENU(state, menu){
			state.menu = menu
		},

		SET_PERMISOS_RUTAS(state, rutas){
			state.permisosRutas = Array.isArray(rutas) ? rutas : []
		},

		SET_ESTATUS_RECEPCION_MAP(state, map){
			const incoming = map && typeof map === 'object' ? map : {}
			const merged = { ...state.estatusRecepcionMap }
			const now = Date.now()
			const GRACE_MS = 5000
			Object.keys(incoming).forEach((key) => {
				const id = Number(key)
				const localTs = state.estatusRecepcionLocalTs[id] || state.estatusRecepcionLocalTs[key]
				if (localTs && now - localTs < GRACE_MS) return
				const estatus = incoming[key]
				merged[id] = estatus
				merged[String(id)] = estatus
			})
			state.estatusRecepcionMap = merged
			state.estatusRecepcionVersion += 1
		},

		SET_ESTATUS_RECEPCION_USUARIO(state, { id_usuario, estatus }){
			if (id_usuario == null) return
			const id = Number(id_usuario)
			state.estatusRecepcionMap = {
				...state.estatusRecepcionMap,
				[id]: estatus,
				[String(id)]: estatus,
			}
			state.estatusRecepcionLocalTs = {
				...state.estatusRecepcionLocalTs,
				[id]: Date.now(),
			}
			state.estatusRecepcionVersion += 1
		},

		MARCAR_RECONOCIMIENTO_MOISES(state){
			state.reconocimientoMoisesVisto = true
		},
	},

	actions:{
		marcarReconocimientoMoises({ commit }){
			commit('MARCAR_RECONOCIMIENTO_MOISES')
		},

		// Valida si el usario existe en la BD
		validarUser({commit}, usuario){
			return new Promise((resolve, reject) => {
			 // console.log (usuario)
			  Vue.http.post('sessions', usuario).then(respuesta=>{
			  	return respuesta.json()
			  }).then(respuestaJson=>{
	         // console.log('respuestaJson',respuestaJson)
					if(respuestaJson == null){
						resolve(false)
					}else{
						resolve(respuestaJson)
        	}
      	}, error => {
        	reject(error)
      	})
			})
		},
    guardarInfo({ commit }, usuario) {
      // Token antes del commit: el watch de App dispara permisos al instante.
      if (usuario && usuario.accessToken) {
        localStorage.setItem('accessToken', usuario.accessToken);
        localStorage.setItem('tlaKey', usuario.accessToken);
      }
      if (usuario && (usuario.iderp == null || usuario.iderp === '') && usuario.id_usuario != null) {
        usuario = { ...usuario, iderp: usuario.id_usuario };
      }
      commit('DATOS_USUARIO', usuario);
      commit('LOGEADO', true);
    },
		GetInfoUser({commit, dispatch}, usuario){
			return new Promise((resolve, reject) => {
			  Vue.http.post('sessions', usuario).then(response=>{
					if(!response.data.length){
						resolve(false)
					}else{
						if(response.data[0].estatus == 0){
							resolve('Tienes que validar tu correo')
						}else if(response.data[0].estatus == 1){
							resolve('No tienes acceso lo sentimos')
						}else{
	        		commit('DATOS_USUARIO',response.data[0])
							commit('LOGEADO', true)
							resolve(true)
						}
	      	}
	    	}, error => {
	      	resolve(false)
	    	})
			})
		},

		cambiarEstatusLlamada({commit},estatusLlamada){
  		commit('CAMBIAR_ESTATUS_LLAMADA',estatusLlamada)
		},

		salirLogin({commit}){
			commit('SALIR')
			localStorage.removeItem('accessToken')
			localStorage.removeItem('tlaKey')
			clearIdleActivityMarker()
		},

		cambiarEscuela({commit}, escuela){
			commit('CAMIAR_ESCUELA', escuela)
		},

		abrirProspecto({commit},prospecto){
			return new Promise((resolve, reject) => {
			  // Vue.http.get('prospectos.prospecto/' + idprospecto).then(response=>{
			  	// console.log(response)
      		commit('ABRIR_PROSPECTO',prospecto)
      		// commit('ABRIR_PROSPECTO',response.data[0])
					resolve(prospecto)
					// resolve(response.data[0])
	    	// }, error => {
	      	// resolve(false)
	    	// })
			})
		},

		addTareas({commit}, tareas){
			commit('ADD_TAREAS', tareas)
		},

		traerProspectosNuevos({commit}, iderp){
			// Vue.http.get('prospectos.nuevos/' + iderp).then(respuesta=>{
			// 	commit('ADD_NUEVOS_PROSPECTOS', respuesta.data.nuevos)
    	// }).catch(error=>{

      // })
		},

		addPermisos({ commit }, menu){
			commit('ADD_MENU', menu)
			commit('SET_PERMISOS_RUTAS', extraerRutasDesdeMenu(menu))
		},

		async cargarEstatusRecepcionMap({ commit }){
			try {
				const res = await axios.get('kpi.ranking.vendedoras.estatus')
				commit('SET_ESTATUS_RECEPCION_MAP', (res.data && res.data.estatusMap) || {})
				return res.data
			} catch (error) {
				console.warn('[login] cargarEstatusRecepcionMap:', error.message || error)
				return { estatusMap: {} }
			}
		},

		async actualizarMiEstatusRecepcion({ commit, dispatch, getters }, estatus){
			const usuario = getters.getdatosUsuarioERPERP
			if (!usuario || usuario.iderp == null) {
				throw new Error('Usuario no disponible')
			}
			if (!estatus) {
				throw new Error('Estatus no válido')
			}
			const id = Number(usuario.iderp)
			const prev = estatusRecepcionDeMap(getters.getEstatusRecepcionMap, id)
			commit('SET_ESTATUS_RECEPCION_USUARIO', { id_usuario: id, estatus })
			try {
				await axios.post('kpi.ranking.vendedoras.estatus', {
					id_usuario: id,
					estatus,
					id_usuario_modifica: id,
				})
				await dispatch('cargarEstatusRecepcionMap')
			} catch (error) {
				commit('SET_ESTATUS_RECEPCION_USUARIO', { id_usuario: id, estatus: prev })
				throw error
			}
		},
	},

	getters:{
		getLogeado(state){
		  return state.login
		},

		getdatosUsuarioERPERP(state){
			return state.datosUsuarioERP
		},

		getEscuela ( state ){
			return state.escuela
		},

		getProspecto (state){
			return state.prospecto
		},

		getEstatusLlamada(state){
			return state.estatusLlamada
		},

		getEstatusLlamadaRecluta(state){
			return state.estatusLlamadaRecluta
		},

		getTareas(state){
			return state.tareas
		},

		getNuevosProspectos(state){
			return state.nuevosProspectos
		},

		getMenu( state ){
			return state.menu
		},

		getPermisosRutas(state){
			return state.permisosRutas
		},

		getEstatusRecepcionMap(state){
			return state.estatusRecepcionMap
		},

		getEstatusRecepcionVersion(state){
			return state.estatusRecepcionVersion
		},

		estatusRecepcionDeUsuario: (state) => (id_usuario) => {
			void state.estatusRecepcionVersion
			return estatusRecepcionDeMap(state.estatusRecepcionMap, id_usuario)
		},

		getReconocimientoMoisesVisto(state){
			return !!state.reconocimientoMoisesVisto
		},

	}
}
